<template lang="pug">
.icon-title 
    .icon
        i(v-bind:class="[icon]" aria-hidden="true")
    .title {{title}}
    .tip(v-if="tip") ({{tip}})
</template>

<script>
    export default {
        props: {
            icon: String,
            title: String,
            tip: String
        } 
    }
</script>

<style scoped>
.icon-title {
    display: inline-block;
    height: 28px;
    margin: 10px 0;
    line-height: 28px;
}

.icon {
    height: 28px;
    width: 28px;
    border-radius: 50%;
    background-color: #66718d;
    text-align: center;
    display: inline-block;
    margin: 0 5px 0 0;
}

.icon i {
    color: #fff;
}

.title, .tip {
    display: inline-block;
    vertical-align: middle;
}

.title {
    font-weight: bold;
    font-size: 16px;
}
.tip {
    color: #999;
    font-size: 12px;
    margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// icon-title.vue?dad3c49c